import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IdentifiedFieldIssue } from '../IFITrackerContext/types'
import { IFIStatus, Permission } from '@cims-online/shared'
import { useIFITrackerContext } from '../IFITrackerContext'

export function useCustom(): CustomRowActionOptions<IdentifiedFieldIssue>[] {
  const { revert } = useIFITrackerContext()
  return [
    {
      type: 'button',
      text: 'Revert',
      permission: Permission.RevertIdentifiedFieldIssue,
      hidden: ({ statusId }) => statusId !== IFIStatus.Closed.id,
      onClick: revert.toggle,
    },
  ]
}
